import type { GetStaticProps } from "next"
import Container from "@/components/common/Container"
import Layout from "@/components/common/Layout"
import MDXRenderer from "@/components/utils/mdx/MDXRenderer"
import { getLegalPageMdx } from "@/utils/legal-mdx"

interface TermsPageProps {
  mdxSource: any
}

export const getStaticProps: GetStaticProps<TermsPageProps> = async () => {
  const mdxSource = await getLegalPageMdx("terms")
  return { props: { mdxSource } }
}

export default function TermsPage({ mdxSource }: TermsPageProps) {
  return (
    <Layout>
      <div className="py-12 max-w-3xl mx-auto">
        <Container>
          <MDXRenderer mdxSource={mdxSource} />
        </Container>
      </div>
    </Layout>
  )
}
